import React from "react";
import LoadingIndicator from "./shared/LoadingIndicator";

export interface TileProps {
  title: string;
  content: string | React.ReactNode;
  icon?: React.ReactNode;
  buttonText?: string;
  onClick?: () => void;
  isTileButtonEnabled?: boolean;
  isLoading?: boolean;
  // Optional second button
  secondaryButtonText?: string;
  onSecondaryClick?: () => void;
  isSecondaryButtonEnabled?: boolean;
}

const TILE_BUTTON_CLASS =
  "bg-[#FCFCFC] border border-primary rounded-xl py-[15px] px-2 min-w-[100px] text-primary transition-all duration-200 hover:bg-gray-50 active:scale-95";

const TILE_BUTTON_STYLE = {
  fontFamily: "Nunito Sans, sans-serif",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0px",
  boxShadow: `
    0px 2px 4px 0px #00000026,
    0px 0px 2px 2px #FCFCFC inset,
    0px -2px 2px 0px #84998380 inset
  `,
};

const Tile: React.FC<TileProps> = ({
  title,
  content,
  icon,
  buttonText,
  onClick,
  isTileButtonEnabled,
  isLoading,
  secondaryButtonText,
  onSecondaryClick,
  isSecondaryButtonEnabled,
}) => {
  return (
    <div
      data-testid="tile-card"
      className="card bg-[#F5F5F5] text-black border-2"
      style={{ borderColor: "#193A3A" }}
    >
      <div className="card-body py-5 px-6">
        <h2
          className="card-title flex items-center"
          style={{ color: "#193A3A" }}
        >
          {icon && (
            <span className="mr-2" style={{ color: "#193A3A" }}>
              {icon}
            </span>
          )}
          {title}
        </h2>
        <div className="pt-5" style={{ color: "#193A3A" }}>
          {isLoading ? (
            <div className="py-8" role="status" aria-label="Loading content">
              <LoadingIndicator customSize="40px" />
            </div>
          ) : typeof content === "string" ? (
            <p>{content}</p>
          ) : (
            <div>{content}</div>
          )}
        </div>

        {((isTileButtonEnabled && onClick && buttonText) ||
          (isSecondaryButtonEnabled &&
            onSecondaryClick &&
            secondaryButtonText)) &&
          !isLoading && (
            <div className="card-actions justify-end pt-5">
              {isTileButtonEnabled && onClick && buttonText && (
                <button
                  className={TILE_BUTTON_CLASS}
                  style={TILE_BUTTON_STYLE}
                  onClick={onClick}
                >
                  {buttonText}
                </button>
              )}
              {isSecondaryButtonEnabled &&
                onSecondaryClick &&
                secondaryButtonText && (
                  <button
                    className={TILE_BUTTON_CLASS}
                    style={TILE_BUTTON_STYLE}
                    onClick={onSecondaryClick}
                  >
                    {secondaryButtonText}
                  </button>
                )}
            </div>
          )}
      </div>
    </div>
  );
};

export default Tile;
